import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.css";

const Pill = ({ title, onClick, color, icon }) => {
  return (
    <div className="pill__wrapper">
      <div className={`pill__container ${color}`} onClick={(event) => {
        event.stopPropagation();
        if (onClick) onClick();
      }}>
        <div className="pill__container--text">{title}</div>
        {icon && (
          <div className="pill__container--icon">
            <FontAwesomeIcon icon={icon} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Pill;